import { withAppCrashIfException } from 'epic';
import { searchCustodianOrClientProductEpic } from 'epic/secondaryMarket/productSearch/searchCustodianOrClientProductEpic';
import { searchUnderlyingsEpic } from 'epic/secondaryMarket/productSearch/searchUnderlyingsEpic';
import { combineEpics } from 'redux-observable';

import { editProductEpic } from './editProductEpic';
import { fetchColumnsDefinitionsEpic } from './fetchColumnsDefinitionsEpic';
import { fetchProductsByKeysEpic } from './fetchProductsByCodeEpic';
import { initializeEpic } from './initializeEpic';
import { loadSearchedCodes } from './loadSearchedCodeEpic';
import {
  columnStateChangedEpic,
  loadPreferenceStateEpic,
  persistPreferenceStateEpic,
} from './preferenceState/preferenceStateEpics';
import { refreshProductByRowIdsEpic } from './refreshProductByRowIdEpic';
import { saveSearchedCodes } from './saveSearchedCodeEpic';
import { syncUserPreferenceProductCodeTypeEpic } from './syncUserPreferenceProductCodeTypeEpic';

export const secondaryMarketProductSearchEpic = () =>
  withAppCrashIfException(
    'secondaryMarketProductSearch',
    combineEpics(
      withAppCrashIfException('initializeEpic', initializeEpic()),
      withAppCrashIfException('fetchProductsByCodeEpic', fetchProductsByKeysEpic()),
      withAppCrashIfException('fetchColumnsDefinitionsEpic', fetchColumnsDefinitionsEpic()),
      withAppCrashIfException('loadSearchedCodes', loadSearchedCodes()),
      withAppCrashIfException('saveSearchedCodes', saveSearchedCodes()),
      withAppCrashIfException('loadPreferenceStateEpic', loadPreferenceStateEpic()),
      withAppCrashIfException('persistPreferenceStateEpic', persistPreferenceStateEpic()),
      withAppCrashIfException('columnStateChangedEpic', columnStateChangedEpic()),
      withAppCrashIfException('editProductEpic', editProductEpic()),
      withAppCrashIfException('searchCustodianOrClientProductEpic', searchCustodianOrClientProductEpic(500)),
      withAppCrashIfException('refreshProductByRowIdsEpic', refreshProductByRowIdsEpic()),
      withAppCrashIfException('syncUserPreferenceProductCodeTypeEpic', syncUserPreferenceProductCodeTypeEpic()),
      withAppCrashIfException('searchUnderlyingsEpic', searchUnderlyingsEpic()),
    ),
  );
